<template>
    <div class="container-default p-5" v-if="pedv">
        <div class="pdf-content" style="height: 130px; min-width: 800px" id="header">
            <div class="row bg-white border border-dark">
                <table class="table table-borderless w-100">
                    <tbody>
                        <tr>
                            <td class="text-left" style="width:30%">
                                <img v-if="image" :src="image" alt="LOGO" height="45px" >
                            </td>
                            <td class="text-center" style="width: 50%;">
                                <h6>{{ pedv.filial[0].nome }}</h6>
                                <span v-if="pedv.tppedv == 'P'">PEDIDO Nº {{ pedv.npedido }}</span>
                                <span v-if="pedv.tppedv != 'P'">ORÇAMENTO Nº {{ pedv.ncotacao }}</span>
                            </td>
                            <td class="text-right" style="width: 20%">
                                Data: {{ pedv.data | formatData() }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="pdf-content" style="min-width: 800px" id="body">
            <div class="row bg-white border-bottom border-left border-right border-dark">
                <table class="table table-borderless table-sm w-100 mb-0">
                    <tbody>
                        <tr>
                            <td width="60%">
                                <span><strong>Cliente:</strong> {{ pedv.part[0].nome }}</span>
                            </td>
                            <td width="40%">
                                <span><strong>CNPJ:</strong> {{ pedv.part[0].cnpjcpf | formatCNPJCPF }}</span>
                            </td>
                        </tr>
                        <tr>
                            <td width="70%">
                                <span><strong>Nome Fantasia:</strong> {{ pedv.part[0].fantasia }}</span>
                            </td>
                            <td width="40%">
                                <span><strong>SUFRAMA:</strong> {{ pedv.part[0].suframa }}</span>
                            </td>
                        </tr>
                        <tr>
                            <td width="50%">
                                <span><strong>Telefone:</strong> {{ pedv.contato.length ? pedv.contato[0].fone1 : '' }}</span>
                            </td>
                            <td width="50%">
                                <span><strong>Email:</strong> {{ pedv.contato.length ? pedv.contato[0].email : '' }}</span>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2">
                                <span>
                                    <strong>Endereço:</strong>
                                    {{ pedv.part[0].ende }} {{ pedv.part[0].endenr }} {{ pedv.part[0].endecomp }} - {{ pedv.part[0].bairro }} - {{ pedv.part[0].nomemun }} - {{ pedv.part[0].uf }} - CEP {{ pedv.part[0].cep }}
                                </span>
                            </td>
                        </tr>
                        <tr v-if="pedv.endeent || pedv.endenrent || pedv.endecompent || pedv.bairroent || pedv.nomemunent || pedv.ufent || pedv.cepent ">
                            <td colspan="2">
                                <span>
                                    <strong>Endereço Entrega:</strong>
                                    {{ pedv.endeent }} {{ pedv.endenrent }} {{ pedv.endecompent }} - {{ pedv.bairroent }} - {{ pedv.nomemunent }} - {{ pedv.ufent }} - CEP {{ pedv.cepent }}
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div style="overflow-x: scroll;" class="row flex-column bg-white border-right border-left border-dark" v-if="hasItem">
                <table class="table table-sm table-bordered tb-detalhes-produto mb-0">
                    <thead>
                        <tr style="font-size: 10px">
                            <th scope="col"> Produto</th>
                            <th scope="col" width="50" class="text-center">Preço Uni</th>
                            <th scope="col" width="50" class="text-center">Quantidade</th>
                            <th scope="col" width="30" class="text-center">Desc(%)</th>
                            <th scope="col" width="30" class="text-center">IPI + ST</th>
                            <th scope="col" width="60" class="text-center">Preço Liq + Imp</th>
                            <th scope="col" width="auto" class="text-center">Subtotal</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, i) in pedv.pedvit" :key="i" v-if="item.servico != 'S'">
                            <td v-if="item.isgrade" colspan=7>
                                <table class="table table-bordered table-sm" style="font-size: 6px" v-if="item.pedvgrade.length > 0">
                                    <template v-for="(dado, i) in dados(item)">
                                        <thead :key="i">
                                            <tr>
                                                <th scope="col"><small style="padding: 0 20px;"></small></th>
                                                <template v-for="(coluna, i) in dado.colunas">
                                                    <th scope="col" style="padding: 0 5px;" :key="i">
                                                        <small style="font-size: 8px; font-weight: bold;">{{ coluna }}</small>
                                                    </th>
                                                </template>
                                            </tr>
                                        </thead>
                                        <tbody :key="i">
                                            <tr v-for="(linha, i) in dado.linhas" :key="i">
                                                <template v-for="(valor, index) in linha">
                                                    <td class="text-center" width="100" :key="index">
                                                       <small v-if="index==0" style="font-size: 8px; font-weight: bold;">{{ valor }}</small>
                                                       <small v-else style="font-size: 8px; font-weight: bold;">{{ valor ? valor : 0 | formatValue(2)}}</small>
                                                    </td>
                                                </template>
                                            </tr>
                                        </tbody>
                                    </template>
                                </table>
                            </td>

                            <td v-if="!item.isgrade" width="45%">
                                <img v-if="item.item[0].url" :src="item.item[0].url" alt="Img" height="35px" class="ml-2 mr-2"> {{ item.item[0].descricao }}
                            </td>
                            <td v-if="!item.isgrade" class="text-right">R${{ item.vlr | formatValue(2,true) }}</td>
                            <td v-if="!item.isgrade" class="text-right">{{ item.qtuni | formatValue(2,true) }} <strong class="ml-1">{{item.uni}}</strong></td>
                            <td v-if="!item.isgrade" class="text-right">{{ item.ptotdes | formatValue(2,true) }}</td>
                            <td v-if="!item.isgrade" class="text-right">{{ itemIpiST(i) | formatValue(2,true) }}</td>
                            <td v-if="!item.isgrade" class="text-right">{{ itemLiqImp(i) | formatValue(2,true) }}</td>
                            <td v-if="!item.isgrade" class="text-right">R${{ item.totliq | formatValue(2,true) }}</td>

                        </tr>
                   </tbody>
                </table>
                <div class="border border-light p-3 mt-n2" v-if="pedv.pedvit.obs">
                    <span><strong>Observações: {{ pedv.pedvit.obs }}</strong></span>
                </div>
            </div>
            <div style="overflow-x: scroll;" class="row flex-column bg-white border-top border-right border-left border-dark" v-if="hasServico">
                <table class="table table-sm table-bordered tb-detalhes-produto mb-0">
                    <thead>
                        <tr style="font-size: 10px">
                            <th scope="col"> Serviço</th>
                            <th scope="col" class="text-center">Preço Unitário</th>
                            <th scope="col" class="text-center">Quantidade</th>
                            <th scope="col" class="text-center">%Desconto</th>
                            <th scope="col" class="text-center" width="100">Subtotal</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, i) in pedv.pedvit" :key="i" v-if="item.servico == 'S'" >
                            <td v-if="item.isgrade" colspan=5>
                                <table class="table table-bordered table-sm" style="font-size: 6px" v-if="item.pedvgrade.length > 0">
                                    <template v-for="(dado, i) in dados(item)">
                                        <thead :key="i">
                                            <tr>
                                                <th scope="col"><small style="padding: 0 20px;"></small></th>
                                                <template v-for="(coluna, i) in dado.colunas">
                                                    <th scope="col" style="padding: 0 5px;" :key="i">
                                                        <small style="font-size: 8px; font-weight: bold;">{{ coluna }}</small>
                                                    </th>
                                                </template>
                                            </tr>
                                        </thead>
                                        <tbody :key="i">
                                            <tr v-for="(linha, i) in dado.linhas" :key="i">
                                                <template v-for="(valor, index) in linha">
                                                   <td  class="text-center" width="100" :key="index">
                                                        <small v-if="index==0" style="font-size: 8px; font-weight: bold;">{{ valor }}</small>
                                                        <small v-else style="font-size: 8px; font-weight: bold;">{{ valor ? valor : 0 | formatValue(2)}}</small>
                                                   </td>
                                                </template>
                                            </tr>
                                        </tbody>
                                    </template>
                                </table>
                            </td>
                            <td v-if="!item.isgrade" width="45%">
                                <img v-if="item.item[0].url" :src="item.item[0].url" alt="Img" height="35px" class="ml-2 mr-2"> {{ item.item[0].descricao }}
                            </td>
                            <td v-if="!item.isgrade" class="text-right">R${{ item.vlr | formatValue(2, true) }}</td>
                            <td v-if="!item.isgrade" class="text-right">{{ item.qtuni | formatValue(2, true) }}</td>
                            <td v-if="!item.isgrade" class="text-right">{{ item.ptotdes | formatValue(2, true) }}</td>
                            <td v-if="!item.isgrade" class="text-right">R${{ item.totliq | formatValue(2, true) }}</td>
                        </tr>
                    </tbody>
                </table>
                <div class="border border-light p-3 mt-n2" v-if="pedv.pedvit.obs">
                    <span><strong>Observações: {{ pedv.pedvit.obs }}</strong></span>
                </div>
            </div>

            <div class="row bg-white border-top border-right border-left border-dark d-flex justify-content-end">
                <table class="border ml-auto">
                    <tr class="col-12">
                        <th class="px-3 border text-right" width="73" scope="col">Total Produtos</th>
                        <td class="border text-right pr-1" width="73">R$ {{ totalProdutos | formatValue(2, true) }}</td>
                    </tr>
                    <tr class="col-12" v-if="hasServico && totalServicos">
                        <th class="px-3 border text-right" width="73" scope="col">Total Serviços</th>
                        <td class="border text-right pr-1"  width="73">R$ {{ totalServicos| formatValue(2, true) }}</td>
                    </tr>
                    <tr v-if="pedv.vlrdesc && !pedv.totdes">
                        <th class="px-3 border text-right" width="73">Descontos</th>
                        <td class="border text-right pr-1"  width="73">R$ {{ pedv.vlrdesc | formatValue(2, true) }}</td>
                    </tr>
                    <tr v-if="pedv.totdes">
                        <th class="px-3 border text-right" width="73">Descontos</th>
                        <td class="border text-right pr-1"  width="73">R$ {{ pedv.totdes | formatValue(2, true) }}</td>
                    </tr>
                    <tr v-if="pedv.vlrfre">
                        <th class="px-3 border text-right" width="73">Frete</th>
                        <td class="border text-right pr-1"  width="73">R$ {{ pedv.vlrfre | formatValue(2, true) }}</td>
                    </tr>
                    <tr v-if="pedv.toticmst">
                            <th class="px-3 border text-right" width="73">ICMS ST</th>
                            <td class="border text-right pr-1"  width="73">R$ {{ pedv.toticmst | formatValue(2, true) }}</td>
                    </tr>
                    <tr v-if="pedv.totipi">
                        <th class="px-3 border text-right" width="73">IPI</th>
                        <td class=" border text-right pr-1"  width="73">R$ {{ pedv.totipi | formatValue(2, true) }}</td>
                    </tr>
                    <tr>
                        <th class="px-3 border text-right" width="73">Total do Pedido</th>
                        <td class=" border text-right pr-1"  width="73">R$ {{ pedv.totger | formatValue(2, true) }}</td>
                    </tr>
                </table>
                <!-- <table class="table table-sm table-bordered mb-n1">
                    <thead>
                        <tr class="text-center">
                            <th scope="col" width="14.2%">Descontos</th>
                            <th scope="col" width="14.2%">ICMS ST</th>
                            <th scope="col" width="14.2%">IPI</th>
                            <th scope="col" width="14.2%">Frete</th>
                            <th scope="col" width="14.2%">Seguro</th>
                            <th scope="col" width="14.2%">Total Produtos</th>
                            <th scope="col" width="14.2%">Total do Pedido</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="text-center">
                            <td>R${{ pedv.totdes | formatValue(2) }}</td>
                            <td>R${{ pedv.toticmst | formatValue(2) }}</td>
                            <td>R${{ pedv.totipi | formatValue(2) }}</td>
                            <td>R${{ pedv.vlrfre | formatValue(2) }}</td>
                            <td>R${{ pedv.vlrseg | formatValue(2) }}</td>
                            <td>R${{ pedv.totmer | formatValue(2) }}</td>
                            <td>R${{ pedv.totger | formatValue(2) }}</td>
                        </tr>
                    </tbody>
                </table> -->
            </div>

            <div class="row bg-white border-top border-bottom border-left border-right border-dark">
                <table class="table table-borderless table-sm w-100 mb-0 p-1">
                    <tbody>
                        <tr>
                            <td colspan="4" class="text-left">
                                <span>
                                    <strong>Transportadora:</strong>
                                    {{ pedv.parttr.length ? pedv.parttr[0].nome : '' }}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-left">
                                <span>
                                    <strong>Pedido do Cliente:</strong>
                                    {{ pedv.pedcli }}
                                </span>
                            </td>
                            <td class="text-left">
                                <span>
                                    <strong>Peso Líquido:</strong>
                                    {{ pedv.pliq | formatValue(2) }}
                                </span>
                            </td>
                            <td class="text-left">
                                <span>
                                    <strong>Peso Bruto:</strong>
                                    {{ pedv.pbru | formatValue(2) }}
                                </span>
                            </td>
                            <td class="text-left">
                                <span>
                                    <strong>Volumes:</strong>
                                    {{ pedv.qtvol | formatValue(2) }}
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="row bg-white border-bottom border-left border-right border-dark">
                <div class="col-md-12 d-flex flex-column p-2">
                    <span><strong>Vendedor:</strong> {{ pedv.usuario_nome }} </span>
                </div>
            </div>
            <div v-if="pedv.condicao" class="row border-bottom border-left border-right border-dark">
                <div class="col-md-12 d-flex flex-column p-2">
                    <span><strong>Condição de Pagamento:</strong> {{ pedv.condicao }} </span>
                </div>
            </div>
            <div v-if="pedv.pedvpar && pedv.pedvpar.length > 0" class="row bg-white border-bottom border-left border-right border-dark">
                    <table class="table table-borderless table-sm w-50 mb-0">
                        <tbody>
                            <tr>
                                <td>
                                    <table class="table table-borderless table-sm mb-0">
                                        <thead>
                                            <tr>
                                                <th scope="col">Vencimento: </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, i) in pedv.pedvpar" :key="i">
                                                <td class="text-left">
                                                    <span>{{ item.dtv | formatData }}</span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                                <td>
                                    <table class="table table-borderless table-sm">
                                        <thead>
                                            <tr>
                                                <th scope="col">Valor Parcela: </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, i) in pedv.pedvpar" :key="i">
                                                <td class="text-left">
                                                    <span>R${{ item.vlr | formatValue(2) }}</span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                        </tbody>
                    </table>
            </div>
            <div class="row bg-white border-bottom border-left border-right border-dark" v-if="pedv.obspedido">
                <div class="col-md-12 p-2" style="width: 95%; white-space: pre-line">
                    <strong>Observações: </strong>
                    {{ pedv.obspedido }}
                </div>
            </div>
            <div class="row bg-white">
                <div class="col-md-12" style="min-height: 100px">
                    <br>
                    <span><strong>Assinatura / Aprovado </strong> </span>
                    <span><strong>______________________________________________________</strong></span>
                </div>
            </div>
            <div class="row bg-white" v-if="pedv.impinfgeraisgarantia == 'S' && pedv.filial && pedv.filial.length && pedv.filial[0].parametros && pedv.filial[0].parametros.pedido && pedv.filial[0].parametros.pedido.observacao_garantia">
                <div class="col-md-12 p-2" style="width: 95%; white-space: pre-line">
                    <div v-html="pedv.filial[0].parametros.pedido.observacao_garantia"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { formatCNPJCPF } from '../shared/utils'
export default {
    props: {
        index: null,
        pedv: null,
        uuid: null,
        image: null
    },
    created(){
    },
    mounted(){
    },
    computed: {
        hasItem(){
            if(this.pedv && this.pedv.pedvit){
                let hasItem = false;
                let itens = this.pedv.pedvit;

                 itens.forEach( item =>{
                    console.log('item', item.servico)
                    if( item.servico == 'N' ) {
                        hasItem = true
                        return;
                    }
                })

                return hasItem
            }
        },
        hasServico(){
            if( this.pedv && this.pedv.pedvit ){
                let hasServico = false
                let itens = this.pedv.pedvit

                itens.forEach( item =>{
                    if( (item.servico == 'S') ) {
                        hasServico = true
                        return;
                    }
                })
                return hasServico
            }
        },
        totalServicos(){
            if( this.hasServico ){
                let itens = this.pedv.pedvit
                let totalServico = 0
                console.log(totalServico)
                itens.forEach(item =>{
                    if(item.servico == 'S'){
                        totalServico += item.totbru
                    }
                    console.log(totalServico)
                })
                console.log(totalServico)
                return totalServico
            }
        },
        totalProdutos(){
            if( this.hasItem ){
                let itens = this.pedv.pedvit
                let totalProduto = 0
                itens.forEach(item =>{
                    if(item.servico != 'S'){
                        totalProduto += item.totbru
                    }
                })
                return totalProduto
            }
        }
    },
    watch: {
        index() {
        }
    },
    methods: {
        getRows(item) {
            let array = []
            // Obtem as linhas dos items com grade
            if (item.pedvgrade && item.pedvgrade.length > 0) {
                item.pedvgrade.map(i => {
                    array.push(i.descricao_linha)
                })
            }

            // Array de linhas sem repeticao
            const rows = array.filter(function (item) {
                return !this[JSON.stringify(item)] && (this[JSON.stringify(item)] = true);
            }, Object.create(null))

            return rows
        },
        getColumns(item) {
            let array = []
            // Obtem as colunas dos objetos com grade
            if (item.pedvgrade && item.pedvgrade.length > 0) {
                item.pedvgrade.map(i => {
                    array.push(i.descricao_coluna)
                })
            }
            // Array de linhas sem repeticao
            const columns = array.filter(function (item) {
                return !this[JSON.stringify(item)] && (this[JSON.stringify(item)] = true);
            }, Object.create(null))

            return columns
        },
        dados(item) {
            const columns = this.getColumns(item)
            const rows = this.getRows(item)
            let linhas = []
            rows.filter(row => {
                let array = new Array((columns.length + 1))
                array.splice(0, 1, row)

                if (item.pedvgrade && item.pedvgrade.length > 0) {
                    item.pedvgrade.map(i => {
                        if (i.descricao_linha == row) {
                            const indice = columns.indexOf(i.descricao_coluna);
                            array.splice((indice + 1), 1, i.qt)
                        }
                    })
                }
                linhas.push(array)
            })
            return [{colunas: columns, linhas: linhas}]
        },
        itemLiqImp(index){
            let item = this.pedv.pedvit[index]

            return item.totliq + item.vipi + item.vicmst
        },
        itemIpiST(index){
            let item = this.pedv.pedvit[index]

            return item.vipi + item.vicmst
        },
        getHtmlContent() {
            setTimeout(() => {
                const contentHeader = document.getElementById('header').innerHTML
                const contentBody = document.getElementById('body').innerHTML
                const htmlContent = [contentHeader, contentBody]
                this.$emit('handleHtmlContent', htmlContent)
            }, 1000);

        }
    }
}
</script>

<style>
div.page_break + div.page_break{
    page-break-before: always;
}
.wrapper-page {
    page-break-after: always;
}

.wrapper-page:last-child {
    page-break-after: avoid;
}
</style>



// WEBPACK FOOTER //
// src/forms/pedido-content-pdf.vue